import { useLocalisation } from '@archipro-website/localisation';
import { useFeatureFlags } from '~/modules/root/hook/use-feature';
import { isUsProductLaunchEnabled } from '~/modules/root/util/is-us-product-launch-enabled';
import { isUS } from '~/modules/root/page/us-footer-gating';
import { PRODUCT_LAUNCH_INSTANT_MS } from './product-launch';

/**
 * Whether the product-launch countdown (and any chrome hung off it, like the
 * hero darkening) should render.
 *
 * It is a pre-launch teaser, so it is scoped to the US market and shown only
 * while the product directory is still gated behind `us_product_launch` AND
 * the launch instant is still ahead. Once ops flip that flag — or the date
 * passes with the flag still off — there is nothing left to count down to, so
 * everything gated here disappears together. NZ/AU never see it — their
 * markets have `allowProducts` set on the Country row.
 *
 * The launch-instant check is a plain read, not a ticking subscription, so
 * consumers don't re-render every second; a page left open across the exact
 * launch moment keeps its gating until the next render, while the clock itself
 * (which does tick) still blanks out on time.
 */
export const useProductLaunchCountdownEnabled = (): boolean => {
    const { country, countryConfig } = useLocalisation();
    const featureFlags = useFeatureFlags();

    if (!isUS(country)) {
        return false;
    }
    if (Date.now() >= PRODUCT_LAUNCH_INSTANT_MS) {
        return false;
    }
    return !isUsProductLaunchEnabled(countryConfig, featureFlags);
};
